module.exports = __webpack_public_path__ + "img/VNPay.bae3ed4d.svg";